import { render } from "./SelectPopup.vue?vue&type=template&id=2c8f791d"
import script from "./SelectPopup.vue?vue&type=script&lang=js"
export * from "./SelectPopup.vue?vue&type=script&lang=js"

import "./SelectPopup.vue?vue&type=style&index=0&id=2c8f791d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__